
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 256 179","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M169.09 249.482C177.192 268.55 195.77 280 215.301 280a50.096 50.096 0 0019.578-3.991c25.509-10.792 37.416-40.176 26.588-65.638L233.3 144.126l73.753-42.824c23.952-13.91 32.065-44.553 18.135-68.45-13.931-23.898-44.644-31.98-68.607-18.093l-62.786 36.456-10.922-25.686C172.056.078 142.734-11.825 117.085-1 91.575 9.794 79.668 39.178 90.497 64.64l15.875 37.337-81.425 47.57C.995 163.424-7.118 193.808 6.813 217.706c9.317 15.973 26.133 25.085 43.415 25.085 8.567 0 17.382-2.389 25.19-6.992l70.459-40.912 23.213 54.595z","fill":"#CE5640"}})])
          )
        }
      }
    